<!-- Desktop and Tablet Version -->
<div
    class="tw-hidden md:tw-flex tw-flex-col tw-gap-[18px] tw-items-center tw-py-[50px] lg:tw-px-[140px] md:tw-px-[70px] tw-bg-[#D9D9D94D]"
>
    <span
        class="lg:tw-text-[28px] md:tw-text-[20px] tw-text-[22px] tw-font-bold tw-text-[#024B3F]"
        >{{ esgData?.title }}</span
    >
    <div class="tw-flex tw-flex-col tw-items-center">
        <span
            class="tw-text-[14px] tw-font-normal tw-text-center lg:tw-w-[873px] md:tw-w-[473px] tw-w-[319px] default-html"
            [innerHTML]="esgData?.description"
        >
        </span>
        <!-- <span
            class="tw-text-[14px] tw-font-normal tw-text-center lg:tw-w-[773px] md:tw-w-[473px] tw-w-[319px]"
            >It's about running your business responsibly.</span
        > -->
    </div>
    <div class="tw-grid tw-grid-cols-3 tw-gap-[18px]">
        <div
            class="tw-bg-white tw-rounded-[20px] lg:tw-px-[20px] md:tw-pt-[33px] tw-pb-[25px] md:tw-px-[20px] tw-flex tw-flex-col tw-gap-[14px] tw-items-center"
        >
            <img
                [src]="cardsData?.icon1_url"
                alt="Survovability Img"
                class="lg:tw-w-[80px] lg:tw-h-[80px] md:tw-w-[50px] md:tw-h-[50px]"
            />
            <span
                class="lg:tw-text-[16px] md:tw-text-[14px] tw-font-bold tw-leading-[22px] tw-text-center"
                >{{ cardsData?.title1 }}</span
            >
            <span
                class="tw-text-center lg:tw-text-[13px] md:tw-text-[12px] tw-leading-[19px] default-html"
                [innerHTML]="cardsData?.description1"
            ></span>
        </div>
        <div
            class="tw-bg-white tw-rounded-[20px] lg:tw-px-[20px] md:tw-pt-[33px] tw-pb-[25px] md:tw-px-[20px] tw-flex tw-flex-col tw-gap-[14px] tw-items-center"
        >
            <img
                [src]="cardsData?.icon2_url"
                alt="Competitiveness Img"
                class="lg:tw-w-[80px] lg:tw-h-[80px] md:tw-w-[50px] md:tw-h-[50px]"
            />
            <span
                class="lg:tw-text-[16px] md:tw-text-[14px] tw-font-bold tw-leading-[22px] tw-text-center"
                >{{ cardsData?.title2 }}</span
            >
            <span
                class="tw-text-center lg:tw-text-[13px] md:tw-text-[12px] tw-leading-[19px] default-html"
                [innerHTML]="cardsData?.description2"
            ></span>
        </div>
        <div
            class="tw-bg-white tw-rounded-[20px] lg:tw-px-[20px] md:tw-pt-[33px] tw-pb-[25px] md:tw-px-[20px] tw-flex tw-flex-col tw-gap-[14px] tw-items-center"
        >
            <img
                [src]="cardsData?.icon3_url"
                alt="Long-Term Growth Img"
                class="lg:tw-w-[80px] lg:tw-h-[80px] md:tw-w-[50px] md:tw-h-[50px]"
            />
            <span
                class="lg:tw-text-[16px] md:tw-text-[14px] tw-font-bold tw-leading-[22px] tw-text-center"
                >{{ cardsData?.title3 }}</span
            >
            <span
                class="tw-text-center lg:tw-text-[13px] md:tw-text-[12px] tw-leading-[19px] default-html"
                [innerHTML]="cardsData?.description3"
            ></span>
        </div>
    </div>
</div>

<!-- Mobile Version -->
<div class="tw-block md:tw-hidden tw-bg-[#D9D9D94D] tw-py-[50px] tw-px-[28px]">
    <div class="tw-flex tw-flex-col tw-gap-[18px] tw-items-left tw-mb-[30px]">
        <span
            class="tw-text-[22px] tw-font-bold tw-text-left tw-leading-[28px] tw-text-[#024B3F]"
        >
            {{ esgData?.title }}
        </span>
        <span
            [innerHTML]="esgData?.description"
            class="tw-text-[14px] tw-font-normal tw-text-left tw-leading-[20px] tw-max-w-[319px] default-html"
        >
        </span>
        <!-- <span
            class="tw-text-[14px] tw-font-normal tw-text-left tw-leading-[20px] tw-max-w-[319px]"
        >
            It's about running your business responsibly.
        </span> -->
    </div>

    <div class="tw-w-full tw-overflow-hidden">
        <p-carousel
            [value]="esgMattersItems"
            [numVisible]="1.3"
            [numScroll]="1"
            [circular]="false"
            [showNavigators]="false"
            [showIndicators]="true"
            [autoplayInterval]="5000"
            contentClass="mobile-esg-matters-carousel"
        >
            <ng-template let-item pTemplate="item">
                <div
                    class="tw-bg-white tw-rounded-[20px] tw-pt-[33px] tw-px-[20px] tw-pb-[25px] tw-flex tw-flex-col tw-gap-[14px] tw-items-center tw-min-h-[280px] tw-w-full"
                >
                    <img
                        [src]="item.image"
                        [alt]="item.title + ' Image'"
                        class="tw-w-[80px] tw-h-[80px] tw-object-contain"
                    />
                    <span
                        class="tw-text-[16px] tw-font-bold tw-leading-[22px] tw-text-center"
                    >
                        {{ item.title }}
                    </span>
                    <span
                        [innerHTML]="item.description"
                        class="tw-text-center tw-text-[13px] tw-leading-[19px] tw-text-[#666666] default-html"
                    >
                    </span>
                </div>
            </ng-template>
        </p-carousel>
    </div>
</div>
